import generateCrudConstants from './baseCrudConstants';

export default generateCrudConstants('COUNTRIES', 'R');



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/constants/countriesConstants.js